<template>
    <div class="modal fade show in" tabindex="-1" role="dialog" @click="$emit('closeModal')" >
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" @click="$emit('closeModal')" ><span
                            aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">{{title}}</h4>
                </div>
                <div class="modal-body">
                    <iframe :src="url" style="width: 100%; height: 100%; border:0; margin-top: -45px; min-height: 60vh"></iframe>
                </div>
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
</template>

<script>
  export default {
    name: 'Modal',
    props: {
      title: String,
      url: String
    },
    data () {
      return {
        body: '',
      }
    },
    created () {
      this.$http
        .get(this.url)
        .then(request => this.parseResult(request))
        .catch(() => this.requestFailed())
    },
    methods: {
      parseResult (req) {
        if (req.status !== 200) {
          this.requestFailed(req)
          return false
        }
        this.body = req.data
      },
      requestFailed (e) {
        alert('an error occured while processing the request: ' + e)
      },
    }
  }
</script>

<style scoped>

</style>
